import { useMemo } from 'react';
import CustomDashboard from '../../components/Dashboard/CustomDashboard';
import SellerPerformanceDashboard from '../../components/Dashboard/SellerPerformanceDashboard';
import { getDashboardEnabledCategories } from '../../utils/dashboardPermissions';

const Dashboard = () => {
  // Calcular el acceso de forma síncrona para evitar renderizados múltiples
  const hasDashboardChartsAccess = useMemo(
    () => getDashboardEnabledCategories().length > 0,
    []
  );

  // Si tiene acceso a reportes visuales, mostrar dashboard personalizable.
  // Si no, caer al dashboard liviano para evitar llamadas a reportes no permitidos.
  return hasDashboardChartsAccess ? <CustomDashboard /> : <SellerPerformanceDashboard />;
};

export default Dashboard;
